/**
 * ViewCharacterInfo
 */
import Config from '../Config';
import Template from './Template';
import Util from '../Util';
import GameInfo from '../GameInfo';

class ViewCharacterInfo {
  public onLoaded: any;

  public onFailed: any;

  private $parent: any;

  private gameUser: any;

  private loginUser: any;

  private $signature: any;

  private writerName: any;

  private _id: string;

  private gameCharacterId: string;

  private gameCharacterName: string;

  private gameCharacterCode: number;

  private communityLevelName: string;

  constructor($parent: any, gameUser: any, loginUser: any) {
    this.$parent = $parent;
    this._id = this.$parent.attr('id');
    this.gameUser = gameUser;
    this.loginUser = loginUser;
    this.gameCharacterId = gameUser.gameCharacterId;
    this.gameCharacterName = gameUser.gameCharacterName;
    this.gameCharacterCode = gameUser.gameCode ? gameUser.gameCode : '';

    this.$signature = jQuery(`#${this._id} .view-signature`);
    this.writerName = this.$signature.find(`.writer`).text() || '';
    this.communityLevelName = this.$signature.find(`.writer .community-level-name`).text() || '';

    this.onLoaded = new Util.Observer();
    this.onFailed = new Util.Observer();

    if ((Config.isProfileWithCharName || Config.isHideGameAccountId || this.gameUser.gameUserUid || this.gameCharacterId) && this.gameUser.gameServerId) {
      this.get();
    } else {
      this.onFailed.emit();
    }
  }

  public get() {
    const apiUrl = GameInfo.getCharacterInfoAPIUrl(
      this.gameUser.gameCharacterName,
      this.gameUser.gameServerId,
      this.gameUser.gameUserUid,
      this.gameCharacterId,
      this.gameCharacterCode
    );

    const _promise = Util.get(apiUrl, 'GET');
    _promise.then(
      (data: any) => {
        if (!data) {
          return '';
        }

        data.name = data.name ? data.name : data.characterName;

        if (!data.name) {
          return '';
        }

        const tmp = this.template(data);
        this.$signature.replaceWith(tmp);
        this.onLoaded.emit();
      },
      (data: any) => {
        this.onFailed.emit();
      }
    );
  }

  private template(data: any) {
    const url = `${GameInfo.gameUserProfile(data.gameAccountId, '', '', data.name, data.serverId, this.gameCharacterId, this.gameCharacterCode)}`;
    const communityLevelName = this.communityLevelName ? Template.communityLevelName(this.communityLevelName) : '';
    let profileThumb = '';
    let profileWriter = '';
    let clan = '';
    let classname = '';
    let servername = '';

    const profileImage = !Util.isUrl(data.profileImageUrl) ? `<img data-src="${data.profileImageUrl}" alt="">` : `<img src="${data.profileImageUrl}" alt="">`;

    if (Config.isMyProfile) {
      profileThumb = `<a href="${url}">${profileImage}</a>`;
      profileWriter = `<a href="${url}">${data.name}</a>`;
    } else {
      profileThumb = profileImage;
      profileWriter = `${data.name}`;
    }

    if (data.guild && data.guild.guildName) {
      if (GameInfo.getSite() === 'bns') {
        clan = `<a href="/world/guild/${data.serverType}/${data.serverId}/${data.guild.guildName}">${data.guild.guildName}</a>`;
      } else {
        clan = `${data.guild.guildName}`;
      }
    }

    if( data.className ) {
      classname = ( data.classBoardUrl ) ?
          `<span class="classname"><a href="${data.classBoardUrl}">${data.className}</a></span>` :
          `<span class="classname">${data.className}</span>`
    }

    if( data.serverName ) {
      servername = (data.serverBoardUrl) ?
          `<span class="servername"><a href="${data.serverBoardUrl}">${data.serverName}</a></span>` :
          `<span class="servername">${data.serverName}</span>`
    }

    return `<div class="view-signature">
		<div class="thumb">${profileThumb}</div>
		<div class="writer">${communityLevelName}${profileWriter}</div>
		<div class="info">
			${classname}
			${servername}
			${clan ? `<span class="clan">${clan}</span>` : ``}
			${data.guild && data.guild.guildName ? `` : ``}
			${data.raceName ? `<span class="race">${data.raceName}</span>` : ``}
			${data.classCardName ? `<span class="class-card">${data.classCardName}</span>` : ``}
		</div>
	</div>`;
  }
}

export default ViewCharacterInfo;
